import React from 'react';

import logo from '../../assets/logo-name.png';
import './Header.scss';

const Header = ()=> {
  return (
    <div className="header">
      <img className="header__logo" src={logo} alt="myplay-logo"/> 
      <span className="header__text">Sites Dashboard</span>   
    </div>
  )
}

export default Header;